import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { useMsal } from '@azure/msal-react';
import logo from 'assets/img/logo-xomePro.png';
import { Link } from 'react-router-dom';

const AzureB2CLogout = ({ ...props }) => {
  const [error, setError] = useState('Please wait while we load the page..');
  const [showLink, setShowLink] = useState(false);
  const { instance } = useMsal();

  useEffect(() => {
    if (instance) {
      var timeoutId = -1;
      instance.logoutRedirect().catch((error) => {
        setError('Please wait while we log you out.');
        timeoutId = setTimeout(() => {
          instance.logoutRedirect().catch((error) => {
            setShowLink(true);
            setError('');
          });
        }, 2000);
      });
      if (timeoutId != -1) { return () => clearTimeout(timeoutId); }
    }
  }, [instance]);

  return (
    <div className='login-background background-header bg_img'>
      <div className='header-logo'>
        <img className='header-logo-image' src={logo} />
      </div>
      <div className='loader-container'>
        <div className='loader'>
          <div className='spinner' />
          <p>{error}</p>
          {
            showLink && 
            <Link to="/">Please click here to proceed</Link>
          }
        </div>
      </div>
    </div>

  );
};

AzureB2CLogout.propTypes = {
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = dispatch => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AzureB2CLogout));
